import { Directive, AfterViewInit, Input, Optional, Host, SkipSelf, Inject } from '@angular/core';
import { AbstractControl, ControlContainer } from '@angular/forms';
import { distinctUntilChanged } from 'rxjs/operators';
import { DatePipe } from '@angular/common';

import { APP_DATE_FORMAT } from '../../config/system.config';

@Directive({
  selector: '[dwDateToString]'
})
export class DateToStringDirective implements AfterViewInit {

  private _dwformat: string;
  private _control: AbstractControl;

  @Input()
  set dwFormat(value: string) {
    if (value) {
      this._dwformat = value;
    }
  }

  @Input() formControlName: string;

  /**
   * The @Optional property decorator tells Angular to return null when it can't find the dependency.
   * The @Host property decorator stops the upward search at the host component.
   * The @SkipSelf decorator allows you to skip the local injector and look up in the hierarchy to find a provider
   *     that satisfies this dependency
   */
  constructor(
    @Optional() @Host() @SkipSelf()
    private controlContainer: ControlContainer,
    @Inject(APP_DATE_FORMAT) private dwDateFormat: string
  ) {
    this._dwformat = dwDateFormat;
  }

  ngAfterViewInit(): void {

    if (this.controlContainer) {
      if (this.formControlName) {
        this._control = this.controlContainer.control.get(this.formControlName);

        // 如果不加 distinctUntilChanged(), 會導致在 setValue() 時, 一直觸發 valueChanges.
        this._control.valueChanges.pipe(distinctUntilChanged()).subscribe(
          (params: Date) => {
            const newdate = (new DatePipe('zh_tw')).transform(params, this._dwformat);
            this._control.setValue(newdate);
          }
        );

      }
    }
  }

}
